import { render, staticRenderFns } from "./habitation.vue?vue&type=template&id=18a6358b&scoped=true"
import script from "./habitation.vue?vue&type=script&lang=js"
export * from "./habitation.vue?vue&type=script&lang=js"
import style0 from "./habitation.vue?vue&type=style&index=0&id=18a6358b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6358b",
  null
  
)

export default component.exports